<div class="mp-grid"
    style="
        height: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
    "
    >
    <div class="mp-row">
        <div class="mp-col mp-col-12">
            <div class="mp-grid">
                <div class="mp-row">
                    <div class="mp-col mp-col-12 ion-text-center">
                        <mp-icon
                            size="large"
                            name="close-circle-outline"
                        ></mp-icon>
                    </div>
                </div>
                <div class="mp-row">
                    <div class="mp-col mp-col-12 ion-text-center">
                        <span
                            class="mp-text ion-text-center"
                            justify-content-center
                            align-items-center
                            style="height: 100%"
                            translate
                        >
                            Store Couldn't be found! Check the URL
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
